import styled, { css } from 'styled-components';

import variables from '../../../styles/variables';
import Link from '../Link/Link';

export const Spinner = styled.div`
  width: 25px;
  height: 25px;
  border: solid 4px;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-cw;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes rotate-cw {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

/* Button sizes */
const sizeCss = css`
  &.large {
    padding: 14px 24px;
    border-radius: 30px;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
  }
  &.medium {
    padding: 12px 16px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.1px;
  }
  &.small {
    padding: 9px 16px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.1px;
  }
  &.xsmall {
    padding: 8px 16px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.2px;
  }

  &.mobile-small {
    @media screen and (max-width: 767px) {
      padding: 9px 16px;
      border-radius: 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0.1px;
    }
  }
`;

/* Button styles */
const styleCss = css`
  &.red {
    background-color: ${variables.colorRed};
    color: ${variables.colorWhite};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      background-color: ${variables.colorRedHover};
      color: ${variables.colorWhite};
    }
  }
  &.black {
    background-color: ${variables.colorBlack};
    color: ${variables.colorWhite};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      background-color: ${variables.colorBlackHover};
      color: ${variables.colorWhite};
    }
  }
  &.white {
    background-color: ${variables.colorWhite};
    color: ${variables.colorBlack};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      background-color: ${variables.colorWhiteHover};
      color: ${variables.colorBlackHover};
    }
  }
  &.outline {
    background-color: ${variables.colorWhite};
    color: ${variables.colorBlack};
    border: 1px solid ${variables.colorBlack};
    transition:
      background-color 0.3s,
      color 0.3s,
      border 0.3s;
    &:hover,
    &:focus {
      background-color: ${variables.colorWhiteHover};
      color: ${variables.colorBlackHover};
      border: 1px solid ${variables.colorBlackHover};
    }
  }
`;

export const InternalButton = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  border: none;
  margin-bottom: 0;
  cursor: pointer;

  ${sizeCss}
  ${styleCss}
`;

export const ExternalButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  border: none;
  margin-bottom: 0;
  cursor: pointer;

  ${sizeCss}
  ${styleCss}
`;

export const FunctionalButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  border: none;
  margin-bottom: 0;
  cursor: pointer;

  ${sizeCss}
  ${styleCss}

  &.red {
    ${Spinner} & {
      border: ${variables.colorWhite};
      :hover {
        border: ${variables.colorWhite};
      }
    }
  }

  &.black {
    ${Spinner} & {
      border: ${variables.colorWhite};
      :hover {
        border: ${variables.colorWhite};
      }
    }
  }

  &.outline {
    ${Spinner} & {
      border: ${variables.colorBlackHover};
    }
  }
`;
